<template>
    <div>
        <div class="row">
            <div class="col-12">
                <p>
                    Zadejte název firmy nebo IČO a prohledejte současný katalog,
                    zda firma již není uvedená v našem katalogu. V případě, že
                    firma již existuje a máte přístup k uvedným emailových
                    adresám firmy, dostanete autorizační email k administraci
                    firmy.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <input
                        v-model="searchText"
                        v-focus
                        placeholder="Zadejte IČO nebo název firmy"
                        :style="inputLoaderStyles"
                        class="form-control"
                        @input="findFirms"
                    />
                </div>
                <button class="button-02 ga-firmy-hledat-firmu" @click="search()">
                    Hledat
                </button>
            </div>
        </div>
        <div class="row pt-5">
            <div class="col-12">
                <h2 v-if="founded_firms !== null">
                    Nalezené firmy "{{ searchText }}"
                </h2>

                <div
                    v-if="founded_firms !== null && founded_firms.length == 0"
                    class="pt-3"
                >
                    <p>Nenalezena žádná firma dle zadaných kritérií</p>
                </div>
                <div id="founded_firms">
                    <div
                        v-for="firm in founded_firms"
                        :key="firm.id"
                        class="row firm"
                    >
                        <div class="col-6">
                            <div class="name">{{ firm.nazev }}</div>
                            <div class="address">{{ firm.adresa }}</div>
                        </div>
                        <div class="col-6">
                            <div v-if="isMyFirm(firm.id_firmy) == true">
                                <span style="color: #DF1F38">Vaše firma</span>
                                <span>&nbsp;</span>
                                <a
                                    :href="
                                        'https://admin.ceskestavby.cz/login.html?loaded=true&user=' +
                                            $store.state.user.id +
                                            '&token=' +
                                            firm.opravny_kod
                                    "
                                    target="_blank"
                                >
                                    Upravit firmu
                                </a>
                            </div>
                            <div v-else>
                                <button
                                    class="button-01"
                                    @click="claimFirm(firm.id_firmy)"
                                >
                                    Nárokovat firmu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="pt-3">
                            <div
                                v-if="founded_firms !== null"
                                class="form-group"
                            >
                                <button
                                    class="button-02"
                                    @click="
                                        $store.commit(
                                            'step/setStep',
                                            'register'
                                        )
                                    "
                                >
                                    Založit novou firmu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormWizardFirmSearch',
    data: function() {
        return {
            result: '',
            debug: false,
        }
    },
    computed: {
        searchText: {
            get() {
                return this.$store.state.search.searchText
            },
            set(value) {
                this.$store.commit('search/setSearchText', value)
            },
        },
        userFirms() {
            return this.$store.state.user.userFirms
        },
        founded_firms() {
            return this.$store.state.search.founded_firms
        },
        inputLoaderStyles() {
            if (this.loader) {
                return {
                    backgroundImage: 'url("/images/ajax-loader.gif")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '95% center',
                }
            } else {
                return {}
            }
        },
        userId() {
            return this.$store.state.user.id
        },
    },
    beforeMount() {
        this.getUser()
        if (this.searchText != '') {
            this.findFirms()
        }
    },
    methods: {
        findFirms() {
            // vymažu dříve nalezené firmy
            this.$store.commit('search/setFoundedFirms', null)

            if (!this.searchText) {
                return
            }

            this.$store.dispatch('loader/setLoader', 'Načítám firmy...')

            this.$store
                .dispatch('search/getFirms', this.searchText)
                .then(status => {
                    if (status) {
                        this.$store.dispatch('loader/setLoader', '')
                    } else {
                        const error = 'Chyba: Nepodařilo se načíst firmy.'
                        console.log(error)
                        this.$store.dispatch('loader/setError', error)
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$store.dispatch('loader/setError', error)
                })
        },
        getUser() {
            this.$store.dispatch(
                'loader/setLoader',
                'Načítám uživatelské údaje...'
            )

            this.$store
                .dispatch('user/getUser')
                .then(status => {
                    if (status) {
                        this.$store.dispatch('loader/setLoader', '')
                    } else {
                        const error = 'Chyba: Uživatel není přihlášen.'
                        console.log(error)
                        this.$store.dispatch('loader/setError', error)
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$store.dispatch('loader/setError', error)
                })
        },
        isMyFirm: function(id_firmy) {
            if (typeof this.userFirms != 'undefined') {
                let m = this.userFirms.some(function(firm) {
                    return firm.id_firmy === id_firmy
                })
                return m
            }
        },
        claimFirm(id_firmy) {
            this.$store.commit('claim/setIdFirmy', id_firmy)
            this.$store.commit('step/setStep', 'claim')
            ga(
                'p.send',
                'event',
                'firmy-narokovat-firmu',
                this.userId,
                id_firmy
            )
        },
        search() {
            this.findFirms()
            ga(
                'p.send',
                'event',
                'firmy-hledat-firmu',
                this.userId,
                this.searchText
            )
        },
    },
}
</script>

<style scoped>
#founded_firms >>> .firm {
    border-bottom: 1px solid #d8d8d8;
    padding-top: 15px;
    padding-bottom: 15px;
}

#founded_firms >>> .address {
    font-weight: bold;
}
</style>
